import ManagerClient from './modals/manager-client/index.vue'
import DocumentsClient from './modals/documents-client/index.vue'
import AddProvider from './modals/add-provider/index.vue'
import ConfigProvider from './modals/config-provider/index.vue'
import ConfigKyc from './modals/config-kyc/index.vue'
import EditProvider from './modals/edit-provider/index.vue'
import EnableProvider from './modals/enable-provider/index.vue'
import ChangePassword from './modals/change-password/index.vue'
import DeleteBasket from './modals/delete-basket/index.vue'
import AddPld from './modals/add-pld/index.vue'
import UpdateCreditClient from './modals/update-credit-client/index.vue'
import EnableClient from './modals/enable-client/index.vue'
import StackTraceJson from './modals/stack-trace-json/index.vue'
import ManagerUser from './modals/manager-user/index.vue'
import EnableUser from './modals/enable-user/index.vue'
import FinancialClient from './modals/financial-client/index.vue'
import ExtractClient from './modals/extract-client/index.vue'
import PeriodExtract from './modals/period-extract/index.vue'
import UpdateBillet from './modals/update-billet/index.vue'
import ConfirmLogout from './modals/confirm-logout/index.vue'
import ConfirmCancelSchedule from './modals/confirm-cancel-schedule/index.vue'
import CloseExtract from './modals/close-extract/index.vue'
import ConfirmDeleteInvoice from './modals/confirm-delete-invoice/index.vue'
import ChangeInfoProvider from './modals/change-info-provider/index.vue'
import ConfirmReturnToList from './modals/confirm-return-to-list/index.vue'
import ViewSelectedHierarquical from './modals/view-selected-hierarquical/index.vue'
import ViewSelectedScheduledBasket from './modals/view-selected-scheduled-basket/index.vue'
import DetailedTradeReport from './modals/detailed-trade-report/index.vue'
import EditInfoSelectedProvider from './edit-info-selected-provider/index.vue'
import CityRisk from './local-bases/city-risk/index.vue'
import RiskProfession from './local-bases/risk-profession/index.vue'
import BlacklistCpf from './local-bases/blacklist-cpf/index.vue'
import ProcessBatchFile from './process-batch-file/index.vue'
import FileUpload from './file-upload/index.vue'
import Loading from './loading/index.vue'
import RedirectAccess from './redirect-access/index.vue'
import ChooseTheme from './choose-theme/index.vue'
import FileDownloadButton from './file-download-button/index.vue'
import MockupBrowser from './mockup-browser/index.vue'
import EditCostVariable from './modals/edit-cost-variable/index.vue'
import EditCostProvider from './modals/edit-cost-provider/index.vue'
import ConfirmSave from './modals/confirm-save/index.vue'

export {
  ManagerClient,
  DocumentsClient,
  UpdateCreditClient,
  EnableClient,
  ManagerUser,
  EnableUser,
  FinancialClient,
  UpdateBillet,
  ConfirmLogout,
  ExtractClient,
  PeriodExtract,
  ConfigProvider,
  ConfigKyc,
  AddProvider,
  EditProvider,
  EnableProvider,
  ChangePassword,
  DeleteBasket,
  AddPld,
  CityRisk,
  RiskProfession,
  BlacklistCpf,
  ProcessBatchFile,
  StackTraceJson,
  FileUpload,
  Loading,
  RedirectAccess,
  ChooseTheme,
  CloseExtract,
  ConfirmDeleteInvoice,
  ChangeInfoProvider,
  ConfirmReturnToList,
  ViewSelectedHierarquical,
  ViewSelectedScheduledBasket,
  DetailedTradeReport,
  EditInfoSelectedProvider,
  FileDownloadButton,
  MockupBrowser,
  ConfirmCancelSchedule,
  EditCostVariable,
  EditCostProvider,
  ConfirmSave
}
